import React from 'react';
import styled from 'styled-components';
import { IntroProps } from './utils';
import TrueImpactText from '../../../design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCertificate } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from '../../../design-system/settings/variables/Colors';
import { SPACERS } from '../../../design-system/settings/variables/Spacers';
import TrueImpactAnimation from '../../../design-system/base/TrueImpactAnimation';
import TrueImpactButton from '../../../design-system/components/TrueImpactButton';

type IntroWelcomeProps = IntroProps

const StyledDiv = styled.div`
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  padding-bottom: ${SPACERS.large};
  .welcome-icon {
    width: 382px;
    height: 382px;
    margin-bottom: -45px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 382px;
    background: radial-gradient(
      50% 50% at 50% 50%,
      #d9eaf1 0%,
      rgba(217, 234, 241, 0) 100%
    );
    svg {
      width: 160px;
      height: 160px;
    }
  }
  .welcome-heading {
    margin-bottom: ${SPACERS.large};
  }
  .welcome-subheading {
    margin-bottom: ${SPACERS.extraLarge};
  }
  .welcome-sub-text {
    margin-top: ${SPACERS.small};
    margin-bottom: ${SPACERS.small};
  }
`;

const IntroWelcome: React.FC<IntroWelcomeProps> = ({ handleNextStep }) => {
  return (
    <TrueImpactAnimation variant="appear">
      <StyledDiv>
        <div className="welcome-icon">
          <FontAwesomeIcon icon={faFileCertificate} color={COLORS.ctaPrimary} />
        </div>
        <TrueImpactText variant="heading-page" className="welcome-heading">
          Welcome to reporting, the True Impact way.
        </TrueImpactText>
        <TrueImpactText variant="body-large" className="welcome-subheading">
          <div>Together, let’s share how you’re changing the world.</div>
          <div className="welcome-sub-text">
            And spend <strong>less time on reporting</strong>.
          </div>
          <div>Here’s how...</div>
        </TrueImpactText>
        <TrueImpactAnimation variant="pulse" animationDelay={10}>
          <TrueImpactButton onClick={handleNextStep}>Continue</TrueImpactButton>
        </TrueImpactAnimation>
      </StyledDiv>
    </TrueImpactAnimation>
  );
};

export default IntroWelcome;
